import { render, staticRenderFns } from "./TaskProgress.vue?vue&type=template&id=3bfcd27a&scoped=true"
import script from "./TaskProgress.vue?vue&type=script&lang=js"
export * from "./TaskProgress.vue?vue&type=script&lang=js"
import style0 from "./TaskProgress.vue?vue&type=style&index=0&id=3bfcd27a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfcd27a",
  null
  
)

export default component.exports